module.exports = {
  publicPath: process.env.VUE_APP_PUBLIC_PATH ? `/${process.env.VUE_APP_PUBLIC_PATH}/` : '/',
  outputDir: 'dist',
  assetsDir: 'static',
  lintOnSave: false,
  transpileDependencies: [
    '@gdev/card-payment',
    'vue-router',
    '@vue/devtools-api'
  ],
  chainWebpack: config => {
    config.module.rules.delete('eslint');
    config.plugin('define').tap(definitions => {
      definitions[0]['process.env.VUE_APP_STAGE'] = JSON.stringify(process.env.VUE_APP_STAGE || '')
      return definitions
    })
  },
  configureWebpack: {
    module: {
      rules: [
        {
          test: /\.m?js$/,
          include: /node_modules\/@gdev\/card-payment/,
          use: {
            loader: 'babel-loader',
            options: {
              presets: ['@babel/preset-env']
            }
          }
        }
      ]
    }
  },
  devServer: {
    host: 'localhost',
    port: 8080,
    historyApiFallback: {
      index: '/dev/index.html',
      rewrites: [
        { from: /^\/dev\/.*/, to: '/dev/index.html' },
        { from: /^\/dev$/, to: '/dev/' }
      ]
    }
  }
}
